import {
    REVERT_RMA_REQUEST,
    REVERT_RMA_RESULT,
    REVERT_RMA_OPEN_MODAL,
    REVERT_RMA_CLOSE_MODAL,
    REVERT_RMA_GET_DEVICE_REQUEST,
    REVERT_RMA_GET_DEVICE_RESULT,
    REVERT_RMA_SET_DEVICE,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    device: null,
    devices: [],
    selectedDevices: [],
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case REVERT_RMA_REQUEST:
            return { ...state, loading: true }

        case REVERT_RMA_RESULT:
            return { ...state, loading: false, result: action.payload }

        case REVERT_RMA_OPEN_MODAL:
            return { ...state, openModal: true, selectedDevices: action.payload }

        case REVERT_RMA_CLOSE_MODAL:
            return { ...state, openModal: false }

        case REVERT_RMA_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case REVERT_RMA_GET_DEVICE_RESULT:
            return { ...state, loading: false, device: action.payload }

        case REVERT_RMA_SET_DEVICE:
            return { ...state, devices: action.payload }


        case CLEAR_REDUX:
            return ["", "REVERT_RMA"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};